import React, { useEffect, useState } from "react";
import { Modal, ModalSize } from "../Modal";
import { SearchInput } from "../input/searchInput";
import { ListTable } from "../Table/listTable/listTable";
import { useParentsList } from "../../hooks/parentsHooks/useParentsList.hooks";
import { useDispatch } from "react-redux";
import { setInfoMessage } from "../../Redux/Slices/alert.slice";
import { SelectedParents } from "../../Redux/Slices/studentAdmission.slice";
import { transformParentsListTableData } from "../../Services/transformer/transformParentsListTableData";
import { parentModalListTable } from "../../Constants/tableTitles/ListTableTitle/parentsList.titles";

interface Props {
  show: boolean;
  onClose: () => unknown;
  onParentsSelect: (value: any) => unknown;
}
export const ParentsListModal = ({ show, onClose, onParentsSelect }: Props) => {
  const [userName, setUserName] = useState<string>("");
  const [userId, setUserId] = useState<string>("");

  const [userNameToSearch, setUserNameToSearch] = useState<string>("");
  const [userIdToSearch, setUserIdToSearch] = useState<string>("");

  const [selectedParents, setSelectedParents] =
    useState<SelectedParents | null>(null);
  const { isLoading, data: parentsData } = useParentsList({
    userIdToSearch,
    userNameToSearch,
  });

  const dispatch = useDispatch();

  useEffect(() => {
    const searchTimeout = setTimeout(() => {
      setUserIdToSearch(userId);
    }, 1000);
    return () => {
      clearTimeout(searchTimeout);
    };
  }, [userId]);

  useEffect(() => {
    const searchTimeout = setTimeout(() => {
      setUserNameToSearch(userName);
    }, 1000);
    return () => {
      clearTimeout(searchTimeout); //cleaning up when it unmounts.
    };
  }, [userName]);

  return (
    <Modal
      show={show}
      onClose={() => {
        setUserIdToSearch("");
        setUserNameToSearch("");
        onClose();
      }}
      modalSize={ModalSize.md}
      modalHeader="Select a parent"
      submissionButton={{
        text: "Select",
        onClick: () => {
          if (!selectedParents) {
            return dispatch(
              setInfoMessage("You need to selected the parents first.")
            );
          }
          onParentsSelect(selectedParents);
          onClose();
        },
      }}
    >
      <div className="flex gap-2 mb-5">
        <SearchInput
          placeHolder="User Id"
          value={userId}
          setValue={(value) => {
            setUserId(value as string);
          }}
        />
        <SearchInput
          placeHolder="User Name"
          value={userName}
          setValue={(value) => {
            setUserName(value as string);
          }}
        />
      </div>
      <div style={{ minWidth: "100%" }}>
        <ListTable
          titles={parentModalListTable}
          data={parentsData?.result}
          isDataLoading={isLoading}
          transformFn={transformParentsListTableData}
          pagination={{
            onPageChange: (pageNo) => {},
            totalPage: parentsData?.totalPages || 1,
          }}
          onSelect={(value) => {
            setSelectedParents(value);
          }}
        />
      </div>
    </Modal>
  );
};
